import "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.umd.js"

CookieConsent.run({
  guiOptions: {
    consentModal: {
      layout: "bar",
      position: "bottom",
      equalWeightButtons: false,
      flipButtons: true,
    },
    preferencesModal: {
      layout: "bar wide",
      position: "right",
      equalWeightButtons: false,
      flipButtons: true,
    },
  },
  categories: {
    necessary: {
      readOnly: true,
    },
    functionality: {},
    analytics: {},
    marketing: {},
  },
  language: {
    default: "en",
    translations: {
      en: {
        consentModal: {
          title: "Hello player, it's cookie time!",
          description:
            "We use cookies and other technologies on our website. Some of them are essential, while others help us to improve this website and your experience. By accepting all cookies, you agree to our use of cookies to deliver, maintain and improve our services and site.",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          showPreferencesBtn: "Manage preferences",
          footer: '<a href="/privacy">Privacy Policy</a>\n<a href="/legal">Legal notice</a>',
        },
        preferencesModal: {
          title: "Consent Preferences Center",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close modal",
          serviceCounterLabel: "Service|Services",
          sections: [
            {
              title: "Cookie Usage",
              description:
                "Personal data may be processed (e.g. IP addresses), for example for personalized ads and content or ad and content measurement. \n Here you will find an overview of all cookies used. You can give your consent to whole categories or display further information and select certain cookies. \n You can find more information about the use of your data in our <a href='/privacy' target='blank'>privacy policy</a>.",
            },
            {
              title: 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
              description: "Essential cookies enable basic functions and are necessary for the proper function of the website.",
              linkedCategory: "necessary",
            },
            {
              title: "Analytics Cookies",
              description: "Analytics cookies collect information about the behavior of website visitors. This way you help us to optimize our website and to improve your experience.",
              linkedCategory: "analytics",
            },
            // {
            //   title: "Advertisement Cookies",
            //   description:
            //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            //   linkedCategory: "marketing",
            // },
          ],
        },
      },
    },
  },
})
